module.exports = __webpack_public_path__ + "media/images/country_flags/cn-e308ca7615a1cd716dd3017451be916e.png";